"use client";

import { AppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import themeLight from "@/lib/theme/light";

export function ThemeProvider({ children }) {
  return (
    <AppRouterCacheProvider>
      <MuiThemeProvider theme={themeLight}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </AppRouterCacheProvider>
  );
}

export default ThemeProvider;
